window.AddMembers = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#cancel-button-id',
                continueButton: '#continue-button-id'
            },
            checkbox:{
                checkBox1: '#add-my-partner',
                checkBox2: '#add-my-children'
            },
            messages:{
                invalidFormMessage: '#add-members-form-invalid-form-message'
            }
        },
        css: {
            invalidCheckboxError: 'vds-checkbox--invalid',
            checkBoxGroup:'.vds-checkbox--contained'
        },
        urls: {
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            errorPageUrl: '/error/error-page',
            partnerDetails: '/my-health-insurance/manage-my-plan/add-members/partner-info',
            dependentCount: '/my-health-insurance/manage-my-plan/add-members/dependent-count',
            cacheAddMembersDetails: '/api/sitecore/AddMembers/CacheAddMembersDetails'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.initializeValidationMessage();
            },
            bindings: function () {
                $(self.elements.buttons.continueButton).on('click', self.func.handleAddMembersRequest);
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelAddMembersRequest);
                $(self.elements.checkbox.checkBox1).on('change', self.func.clearValidationMessage);
                $(self.elements.checkbox.checkBox2).on('change', self.func.clearValidationMessage);
            },
            initializeValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage).hide();
            },
            handleAddMembersRequest: function (event) {
                event.preventDefault();
                self.func.clearValidationMessage();

                if (!$(self.elements.checkbox.checkBox1).is(':checked') &&
                    !$(self.elements.checkbox.checkBox2).is(':checked')) {
                    $(self.elements.messages.invalidFormMessage).show();
                    $(self.css.checkBoxGroup).addClass(self.css.invalidCheckboxError);
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: self.urls.cacheAddMembersDetails,
                    data: {isAddPartnerDetails: $(self.elements.checkbox.checkBox1).is(':checked'),
                        isAddChildrenDetails: $(self.elements.checkbox.checkBox2).is(':checked')},
                    success: self.func.success,
                    error: self.func.error
                });

            },
            success: function () {
                const url = $(self.elements.checkbox.checkBox1).is(':checked') ?
                    self.urls.partnerDetails : self.urls.dependentCount;
                window.location.href = url;
            },
            error: function () {
                window.location.href = self.urls.errorPageUrl;
            },
            cancelAddMembersRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            clearValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage).hide();
                $(self.css.checkBoxGroup).removeClass(self.css.invalidCheckboxError);
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('addMembers' === $('#add-members-form').data('feature')) {
        window.AddMembers.Init();
    }
});
